import React__default from 'react';
import classnames from 'classnames';
import { Select } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import { getEyeLabel } from '../utils.js';

const SelectQuantity = ({ parentId , isDisabled , options , onChange , selectedQuantity , showLabel , className  })=>{
    const intl = useIntl();
    const selectId = `${parentId}-quantity-select`;
    const eyeLabel = getEyeLabel(intl, parentId);
    const label = intl.getLabel('products.contactLenses.quantitySelect.label');
    // prefill the selectbox if we have a quantity higher than 0.
    const optionKeys = Object.keys(options);
    const initialSelection = selectedQuantity !== 0 ? {
        value: optionKeys[selectedQuantity - 1]
    } : {
        value: optionKeys[0]
    };
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, showLabel && /*#__PURE__*/ React__default.createElement("label", {
        className: classnames('select-quantity__label', `${className}__label`),
        htmlFor: selectId
    }, label), /*#__PURE__*/ React__default.createElement(Select, {
        id: selectId,
        name: "quantity-selector",
        "aria-label": `${label} ${eyeLabel}`,
        className: classnames('select-quantity__select', className),
        options: options,
        initialState: initialSelection,
        disabled: isDisabled,
        onChange: onChange,
        "data-t": "select-quantity"
    }));
};

export { SelectQuantity };
//# sourceMappingURL=SelectQuantity.js.map
